
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/immoneuf/[shopId]",
      function () {
        return require("private-next-pages/immoneuf/[shopId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/immoneuf/[shopId]"])
      });
    }
  